import { Route, Routes } from "react-router-dom";

import { useGetProfile } from "../libs/api/react-query";

import PrivateRoute from "./PrivateRoute";

import {
  PermissionsAction,
  PermissionsPosModule,
  PermissionsScope
} from "@/common/types/permissions.types";
import Contracts from "@/modules/Contracts";
import ContractsCreate from "@/modules/Contracts/pages/Create";
import { ContractsEdit } from "@/modules/Contracts/pages/Edit";
import { ContractView } from "@/modules/Contracts/pages/View";

function ContractsRoutes(): JSX.Element {
  const userProfile = useGetProfile();
  const permissions = userProfile.data?.data?.role.permissions;

  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.CONTRACTS}
            action={PermissionsAction.LIST}
          >
            <Contracts
              canCreate={permissions[PermissionsScope.POS][
                PermissionsPosModule.CONTRACTS
              ]?.some(
                action =>
                  action === PermissionsAction.ALL ||
                  action === PermissionsAction.CREATE
              )}
              canRead={permissions[PermissionsScope.POS][
                PermissionsPosModule.CONTRACTS
              ]?.some(
                action =>
                  action === PermissionsAction.ALL ||
                  action === PermissionsAction.READ
              )}
            />
          </PrivateRoute>
        }
      />
      <Route
        path=":id/edit"
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.CONTRACTS}
            action={PermissionsAction.UPDATE}
          >
            <ContractsEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="create"
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.CONTRACTS}
            action={PermissionsAction.CREATE}
          >
            <ContractsCreate />
          </PrivateRoute>
        }
      />
      <Route
        path=":id"
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.CONTRACTS}
            action={PermissionsAction.READ}
          >
            <ContractView />
          </PrivateRoute>
        }
      />
      <Route
        path=":id/occurrence"
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.CONTRACTS}
            action={PermissionsAction.READ}
          >
            <ContractView />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default ContractsRoutes;
